import { finalize } from 'rxjs/operators';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/ng-model-change-debounced/ng-model-change-debounced.directive";
const _c0 = a0 => ({ "is-invalid": a0 });
function InviteFriendModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "p");
    i0.ɵɵtext(2, " We appreciate your enthusiastic support, however, we have a limit on referral submissions. We\u2019ll review your submissions and get back to you soon. In the meantime, please contact us with any questions. ");
    i0.ɵɵelementEnd()();
} }
function InviteFriendModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "p", 13);
    i0.ɵɵtext(2, " Thank you for inviting friends to YCharts ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, " We'll email them some information on how to get started. ");
    i0.ɵɵelementEnd()();
} }
function InviteFriendModalComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "label", 19);
    i0.ɵɵtext(3, " Email ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 20)(5, "label")(6, "input", 21, 1);
    i0.ɵɵlistener("debouncedChangeHandler", function InviteFriendModalComponent_div_7_div_3_Template_input_debouncedChangeHandler_6_listener() { const $index_r3 = i0.ɵɵrestoreView(_r2).index; const emailInput_r4 = i0.ɵɵreference(7); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.validateEmail($index_r3, emailInput_r4)); });
    i0.ɵɵtwoWayListener("ngModelChange", function InviteFriendModalComponent_div_7_div_3_Template_input_ngModelChange_6_listener($event) { const email_r6 = i0.ɵɵrestoreView(_r2).$implicit; i0.ɵɵtwoWayBindingSet(email_r6.value, $event) || (email_r6.value = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 22);
    i0.ɵɵtext(9, " Invalid email format. ");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const email_r6 = ctx.$implicit;
    const $index_r3 = ctx.index;
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("email", true)("name", "emailVal" + $index_r3)("ngClass", i0.ɵɵpureFunction1(5, _c0, !email_r6.isValid));
    i0.ɵɵtwoWayProperty("ngModel", email_r6.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", email_r6.isValid);
} }
function InviteFriendModalComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 23)(2, "label", 19);
    i0.ɵɵtext(3, " Email ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 24)(5, "a", 25);
    i0.ɵɵlistener("click", function InviteFriendModalComponent_div_7_div_4_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r7); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.addEmailField()); });
    i0.ɵɵelementStart(6, "strong");
    i0.ɵɵtext(7, " + Add another email ");
    i0.ɵɵelementEnd()()()();
} }
function InviteFriendModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "p");
    i0.ɵɵtext(2, " Enter email address to invite a friend to YCharts. ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, InviteFriendModalComponent_div_7_div_3_Template, 10, 7, "div", 15)(4, InviteFriendModalComponent_div_7_div_4_Template, 8, 0, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.emails);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.showAddEmail);
} }
function InviteFriendModalComponent_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵlistener("click", function InviteFriendModalComponent_a_10_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r4 = i0.ɵɵnextContext(); const emailForm_r9 = i0.ɵɵreference(3); return i0.ɵɵresetView(emailForm_r9.invalid || ctx_r4.isEmpty() || ctx_r4.processingRequest || ctx_r4.submitReferral()); });
    i0.ɵɵtext(1, " Send ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const emailForm_r9 = i0.ɵɵreference(3);
    i0.ɵɵproperty("disabled", emailForm_r9.invalid || ctx_r4.isEmpty() || ctx_r4.processingRequest);
} }
function InviteFriendModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("click", function InviteFriendModalComponent_div_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.closeModal()); });
    i0.ɵɵtext(1, " Close ");
    i0.ɵɵelementEnd();
} }
/**
 *
 * Invite Friend Modal Component
 *
 * This component is responsible for:
 *  1. Accepting user input of the email addresses for friends they wish to invite to YCharts
 *  2. Handling when the Send button is clicked
 *
 */
export class InviteFriendModalComponent {
    constructor(accountsService) {
        this.accountsService = accountsService;
        this.emails = [
            {
                value: '',
                isValid: true,
            },
        ];
        this.modalOpen = false;
        this.processingRequest = false;
        this.showAddEmail = true;
        this.showCompletionModal = false;
        this.showLimitReached = false;
        this.MAX_NUM_EMAILS = 5;
        this.reset();
    }
    openModal() {
        /**
         * In AngularJS we would use $scope.$broadcast and $scope.$on to open modals from the parent component.
         * This pattern no longer exists so we call `openModal` directly from the parent using a `ViewChild`
         */
        this.modalOpen = true;
    }
    closeModal() {
        /**
         * Closes the modal and resets to the default state.
         */
        this.modalOpen = false;
        this.reset();
    }
    submitReferral() {
        /**
         * POSTs the emails to the backend view. Depending on whether the backend returns a success or error response,
         * we show various messages to the user.
         */
        this.processingRequest = true;
        const emailValues = this.emails.filter((email) => !!email.value).map((email) => email.value.trim());
        const combinedEmails = `${emailValues.join()},`;
        this.accountsService
            .postReferFriends(combinedEmails)
            .pipe(
        // Finalize gets called after both `next` and after `error`
        finalize(() => {
            this.processingRequest = false;
        }))
            .subscribe({
            next: (res) => {
                if (res.status === 200) {
                    this.showCompletionModal = true;
                }
            },
            error: (error) => {
                if (error.status === 400) {
                    const invalidEmails = error.error.invalid_emails;
                    for (let i = 0; i < this.emails.length; i += 1) {
                        this.emails[i].isValid = !invalidEmails.includes(this.emails[i].value);
                    }
                }
                else if (error.status === 403) {
                    if (error.error.over_email_limit) {
                        this.showLimitReached = true;
                    }
                }
            },
        });
    }
    validateEmail(emailIndex, emailInput) {
        /**
         * Updates our email array by checking if the NgModel has valid input.
         * The line `[email]="true"` from the template is what adds email validation to the model.
         * NOTE: An email like "banana@ycharts" would be considered valid by the frontend, but not the backend.
         */
        const email = this.emails[emailIndex];
        email.isValid = emailInput.valid || false;
    }
    addEmailField() {
        /**
         * As long as we have not hit MAX_NUM_EMAILS, add an empty email to the array.
         */
        this.emails.push({
            value: '',
            isValid: true,
        });
        if (this.emails.length === this.MAX_NUM_EMAILS) {
            this.showAddEmail = false;
        }
    }
    isEmpty() {
        /**
         * Returns true if and only if every email has no value.
         */
        return this.emails.every((email) => !email.value);
    }
    reset() {
        /**
         * Resets all variables to their default state. This is called whenever the modal is closed, meaning we will
         * always start with a fresh slate each time the modal is opened.
         */
        this.showLimitReached = false;
        this.showCompletionModal = false;
        this.showAddEmail = true;
        this.processingRequest = false;
        this.emails = [
            {
                value: '',
                isValid: true,
            },
        ];
    }
}
InviteFriendModalComponent.ɵfac = function InviteFriendModalComponent_Factory(t) { return new (t || InviteFriendModalComponent)(i0.ɵɵdirectiveInject(i1.AccountsService)); };
InviteFriendModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InviteFriendModalComponent, selectors: [["ycn-invite-friend-modal"]], decls: 12, vars: 7, consts: [["emailForm", "ngForm"], ["emailInput", "ngModel"], [3, "closeModalHandler", "extraModalClasses", "open"], ["header", "Invite a Friend", 3, "closeModalHandler"], ["name", "emailForm"], [1, "modal-body"], ["class", "modal-section section-invite", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [1, "modal-footer"], [1, "modal-footer-actions"], ["class", "btn btn-primary", "href", "javascript:void(0)", "role", "button", "ycnDisabled", "", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], [1, "modal-section", "section-invite"], [1, "modal-section-title"], [1, "modal-section"], ["class", "row form-row", 4, "ngFor", "ngForOf"], ["class", "row form-row", 4, "ngIf"], [1, "row", "form-row"], [1, "col-auto", "form-inline", "base-height"], [1, "form-label", "form-label-thin"], [1, "col"], ["type", "email", "ycnNgModelChangeDebounced", "", "placeholder", "email@company.com", 1, "form-control", "referral-email", 3, "debouncedChangeHandler", "ngModelChange", "email", "name", "ngClass", "ngModel"], [1, "feedback", "feedback-invalid", 3, "hidden"], [1, "invisible", "col-auto"], [1, "col", "form-inline", "base-height"], ["href", "javascript:void(0)", 1, "text-blue", 3, "click"], ["href", "javascript:void(0)", "role", "button", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], [1, "btn", "btn-secondary", 3, "click"]], template: function InviteFriendModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function InviteFriendModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function InviteFriendModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "form", 4, 0)(4, "div", 5);
        i0.ɵɵtemplate(5, InviteFriendModalComponent_div_5_Template, 3, 0, "div", 6)(6, InviteFriendModalComponent_div_6_Template, 5, 0, "div", 6)(7, InviteFriendModalComponent_div_7_Template, 5, 2, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
        i0.ɵɵtemplate(10, InviteFriendModalComponent_a_10_Template, 2, 1, "a", 10)(11, InviteFriendModalComponent_div_11_Template, 2, 0, "div", 11);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm modal-fix-scroll")("open", ctx.modalOpen);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showLimitReached);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showCompletionModal);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.showCompletionModal && !ctx.showLimitReached);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.showCompletionModal && !ctx.showLimitReached);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showCompletionModal || ctx.showLimitReached);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.DisabledDirective, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.EmailValidator, i4.NgModel, i4.NgForm, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent, i7.NgModelChangeDebouncedDirective], encapsulation: 2 });
